import { render, staticRenderFns } from "./VerticalUnpurchased.vue?vue&type=template&id=18084ead"
import script from "./VerticalUnpurchased.vue?vue&type=script&lang=js"
export * from "./VerticalUnpurchased.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports